<template>
  <div class="lang-switcher" @click="toggleMenu" v-click-outside="closeMenu">
    <span class="lang-btn">{{ currentLang === 'zh-CN' ? '中文' : 'EN' }}</span>
    <div v-if="showMenu" class="lang-menu">
      <div 
        class="lang-option" 
        :class="{ active: currentLang === 'zh-CN' }"
        @click="switchLang('zh-CN')"
      >中文</div>
      <div 
        class="lang-option" 
        :class="{ active: currentLang === 'en-US' }"
        @click="switchLang('en-US')"
      >English</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    switchLang(lang) {
      this.$switchLang(lang);
      this.showMenu = false;
    }
  }
};
</script>

<style scoped>
.lang-switcher {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.lang-btn {
  display: inline-block;
  padding: 4px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
  background: #fff;
  transition: all 0.2s;
}
.lang-btn:hover {
  border-color: #667eea;
  color: #667eea;
}
.lang-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 100px;
}
.lang-option {
  padding: 8px 16px;
  font-size: 13px;
  color: #333;
  transition: all 0.2s;
}
.lang-option:hover {
  background: #f5f5f5;
}
.lang-option.active {
  color: #667eea;
  font-weight: bold;
}
.lang-option:first-child {
  border-radius: 4px 4px 0 0;
}
.lang-option:last-child {
  border-radius: 0 0 4px 4px;
}
</style>
